import { render } from "./ForcedMultiFactorAuthentication.vue?vue&type=template&id=070a09b3&scoped=true"
import script from "./ForcedMultiFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./ForcedMultiFactorAuthentication.vue?vue&type=script&lang=js"

import "./ForcedMultiFactorAuthentication.vue?vue&type=style&index=0&id=070a09b3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070a09b3"]])

export default __exports__